import { errorTracker } from './errorTracker';

let initialized = false;

export function initializeGlobalErrorHandling(): void {
  if (initialized) return;
  
  // Handle uncaught JavaScript errors
  window.onerror = (message, source, lineno, colno, error) => {
    const errorMessage = typeof message === 'string' ? message : 'Unknown error';
    const customData = {
      source,
      lineno,
      colno,
      errorType: 'uncaught_error'
    };

    if (error instanceof Error) {
      // Skip if already tracked (e.g., from API requests)
      if (!(error as any)._tracked) {
        errorTracker.captureError(error, 'error', customData);
      }
    } else {
      errorTracker.captureError(errorMessage, 'error', customData);
    }

    // Return false to let the default error handling continue
    return false;
  };

  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    let errorMessage = 'Unhandled promise rejection';
    let error: Error | undefined;

    if (reason instanceof Error) {
      error = reason;
      errorMessage = reason.message;
    } else if (typeof reason === 'string') {
      errorMessage = reason;
    } else {
      errorMessage = 'Unhandled promise rejection: ' + String(reason);
    }

    const customData = {
      errorType: 'unhandled_promise_rejection',
      reason: typeof reason === 'object' ? JSON.stringify(reason) : String(reason)
    };

    if (error) {
      // Skip if already tracked (e.g., from API requests)
      if (!(error as any)._tracked) {
        errorTracker.captureError(error, 'error', customData);
      }
    } else {
      errorTracker.captureError(errorMessage, 'error', customData);
    }

    // Prevent the default console.error
    event.preventDefault();
  });

  initialized = true;
}

// Svelte component error boundary helper
export function createSvelteErrorBoundary(componentName: string) {
  return (error: Error) => {
    errorTracker.captureError(error, 'error', {
      errorType: 'svelte_component_error',
      componentName
    });
  };
}